export default __webpack_public_path__ + "static/media/scr7.3f6be0f5.webp";